import { render, staticRenderFns } from "./AlternativesImportPage.vue?vue&type=template&id=1b78d1e8&scoped=true"
import script from "./AlternativesImportPage.vue?vue&type=script&lang=ts"
export * from "./AlternativesImportPage.vue?vue&type=script&lang=ts"
import style0 from "./AlternativesImportPage.vue?vue&type=style&index=0&id=1b78d1e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b78d1e8",
  null
  
)

export default component.exports